import { useQueryClient } from "@tanstack/react-query";
import { ChangePasswordForm, KeyValue, PageHeader, Panel, SessionsPanel, toast, TwoFactorPanel } from "@hostdock/ui";
import { api, SESSION_KEY } from "../api";
import { useSession, useSetSession } from "../session";

export function AccountPage() {
  const { session, logout } = useSession();
  const setSession = useSetSession();
  const qc = useQueryClient();

  return (
    <>
      <PageHeader title="My account" description="Your sign-in details and security." />
      <div className="flex max-w-4xl flex-col gap-5">
        <Panel title="Profile">
          <KeyValue
            items={[
              { label: "Name", value: session.user.name },
              { label: "Email", value: session.user.email },
              { label: "Role", value: session.role.name },
            ]}
          />
        </Panel>
        <Panel title="Two-factor authentication">
          <TwoFactorPanel api={api.account} enabled={session.user.mfaEnabled} required={session.mfaRequired} onChanged={() => void qc.invalidateQueries({ queryKey: SESSION_KEY })} />
        </Panel>
        <Panel title="Password" description="Changing your password signs out your other sessions.">
          <div className="max-w-sm">
            <ChangePasswordForm
              api={api.account}
              onChanged={(s) => {
                setSession(s);
                toast.success("Password changed");
                void qc.invalidateQueries({ queryKey: ["account", "sessions"] });
              }}
            />
          </div>
        </Panel>
        <Panel title="Active sessions" flush>
          <SessionsPanel api={api.account} onSignedOut={() => void logout()} />
        </Panel>
      </div>
    </>
  );
}
